import React__default from 'react';
import { D as DisclaimerText } from './FormLayout.styles-BzYy_4z2.js';

const FormLayoutDisclaimer = ({
  renderDisclaimer
}) => /*#__PURE__*/React__default.createElement(DisclaimerText, null, typeof renderDisclaimer === 'function' ? renderDisclaimer() : renderDisclaimer);

export { FormLayoutDisclaimer as F };
//# sourceMappingURL=FormLayoutDisclaimer-tjJTTliS.js.map
